import clickAudio from "./assets/audio/click.mp3";
import themeSongAudio from "./assets/audio/oregon-trail.mp3";
import howdyAudio from "./assets/audio/howdy.mp3";
import whipCrackAudio from "./assets/audio/whip-crack.mp3";
import gameOverAudio from "./assets/audio/game-over.mp3";
import potDingAudio from "./assets/audio/pot-ding.mp3";
import yeehawAudio from "./assets/audio/yeehaw.mp3";

const audioFiles = {
  click: clickAudio,
  themeSong: themeSongAudio,
  howdy: howdyAudio,
  whipCrack: whipCrackAudio,
  gameOver: gameOverAudio,
  potDing: potDingAudio,
  yeehaw: yeehawAudio,
};

class AudioManager {
  constructor(audioFiles) {
    this.audioFiles = audioFiles;
    this.audios = new Map();
    this.volume = 1.0;
    this.isMuted = false;

    // Add all audio files from assets/audio
    this.initializeAudioFiles();
  }

  initializeAudioFiles() {
    // Preload all audio files
    for (const [id, path] of Object.entries(this.audioFiles)) {
      const audio = new Audio(path);
      audio.preload = true;
      this.audios.set(id, audio);
    }
  }

  // Get audio by ID
  getAudio(id) {
    return this.audios.get(id);
  }

  // Play audio by ID
  play(id) {
    return new Promise((resolve, reject) => {
      const audio = this.getAudio(id);
      if (this.isMuted) {
        resolve();
      } else if (audio) {
        audio.currentTime = 0; // Reset to start
        audio.volume = this.volume;
        audio.addEventListener("ended", resolve);
        audio.play();
      } else {
        reject(new Error(`Audio file ${id} not found`));
      }
    });
  }

  // Set global volume (0.0 to 1.0)
  setVolume(value) {
    this.volume = Math.max(0, Math.min(1, value));
    this.updateAllVolumes();
  }

  // Mute/unmute all audio
  setMute(mute) {
    this.isMuted = mute;
    this.updateAllAudio();
  }

  // Update volumes for all audio files
  updateAllVolumes() {
    for (const audio of this.audios.values()) {
      audio.volume = this.isMuted ? 0 : this.volume;
    }
  }

  updateAllAudio() {
    if (this.isMuted) {
      for (const audio of this.audios.values()) {
        audio.currentTime = 0;
        audio.pause();
      }
    } else {
      for (const audio of this.audios.values()) {
        audio.currentTime = 0;
      }
    }
  }
}

// Create a singleton instance
const audioManager = new AudioManager(audioFiles);
export default audioManager;
